import * as React from "react"
import { Appearance, StyleProp, TextStyle, ViewStyle } from "react-native"
import { observer } from "mobx-react-lite"
import { color } from "../../theme"
import { Text } from "../text/text"
import { View } from "native-base"

const CONTAINER: ViewStyle = {
  // backgroundColor: color.palette.white,
  paddingLeft: 16,
  paddingVertical: 8
}

const TEXT: TextStyle = {
  marginLeft: 4,
  marginVertical: 4
}

const VALUE: ViewStyle = {
  flexDirection: 'row',
  alignItems: "center"
}

const UNIT: TextStyle = {
  marginLeft: 4,
  color: color.palette.dust500
}

const PONDS_ACTIVE: TextStyle = {
  marginLeft: 4,
  color: color.palette.dust500
}

const ROW: ViewStyle = {
  flexDirection: 'row'
}

export interface PredictionsHeaderProps {
  /**
   * An optional style override useful for padding & margin.
   */
  farmName?: string
  unit?: string
  isSR?: boolean
  value?: number
  pond?: number
  style?: StyleProp<ViewStyle>
  activePond?: number
  colorScheme?: "light" | "dark"
}

/**
 * Describe your component here
 */
export const PredictionsHeader = observer(function PredictionsHeader(props: PredictionsHeaderProps) {
  const { colorScheme = "light" || Appearance.getColorScheme() } = props;
  return (
    <View style={CONTAINER}>
      <Text preset="title3" text={props.farmName} colorScheme={colorScheme} />
      <Text preset="body3" tx={props.isSR ? "average" : "total"} style={TEXT} colorScheme={colorScheme} />
      <View style={VALUE}>
        <Text preset="display1" colorScheme={colorScheme}>{props.value}</Text>
        <Text preset="display2" text={props.unit} style={UNIT} colorScheme={colorScheme} />
      </View>
      <View style={ROW}>
        <Text preset="body3" style={PONDS_ACTIVE} text={`from ${props.activePond}`} colorScheme={colorScheme}/>
        <Text preset="body3" style={PONDS_ACTIVE} tx="predictions.activePond" colorScheme={colorScheme}/>
      </View>
    </View>
  )
})
